<template>
  <div class="detail">
    <video-player
      :baseUrl="baseUrl"
      :videoUrl="videoUrl"
      :title="title"
      :setNum="setNum"
      :num="num"
      :videoFormat="videoFormat"
    ></video-player>

    <div class="content" style="clear: both; height: 700px">
      <evaluate-box></evaluate-box>
      
      <ranking-box :rankingList="rankingList"></ranking-box>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "./VideoPlayer.vue";
import EvaluateBox from "./EvaluateBox.vue";
import RankingBox from "./RankingBox.vue";
import videos from "../ossVideo2";

export default {
  name: "Detail7",
  components: { VideoPlayer, EvaluateBox, RankingBox },
  data() {
    return {
      baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video7/",
      videoUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video7/1.mp4",
      title: "熊猫博士看世界：安全消防课",
      setNum: 3,
      videoFormat: 'mp4',
      num: "1",
      rankingList: videos.puzzleRankingList
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  padding: 110px 100px 20px;
  .content {
    position: relative;
  }
}
</style>


